import React, { useRef, useState, useEffect, useCallback } from 'react';
import ReactDOMServer from 'react-dom/server';
import { FaPaintBrush, FaBolt, FaWater, FaBuilding, FaSeedling, FaSnowflake, FaShieldAlt, FaHammer, FaToolbox, FaHandshake, FaSearch, FaLocationArrow } from 'react-icons/fa';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import * as turf from '@turf/turf';

mapboxgl.accessToken = 'pk.eyJ1IjoicWJhbml0byIsImEiOiJjbDIycnpzbmcxY3pnM2RtaTMyc2x0NHdkIn0.XRx68tO2XL7DSulvPxu6Ng';

const icons = {
  pintor: <FaPaintBrush style={{ color: 'blue', fontSize: '30px' }} />,
  electricista: <FaBolt style={{ color: 'yellow', fontSize: '30px' }} />,
  fontanero: <FaWater style={{ color: 'cyan', fontSize: '30px' }} />,
  albanil: <FaHammer style={{ color: 'orange', fontSize: '30px' }} />,
  carpintero: <FaToolbox style={{ color: 'brown', fontSize: '30px' }} />,
  jardinero: <FaSeedling style={{ color: 'green', fontSize: '30px' }} />,
  aire_acondicionado: <FaSnowflake style={{ color: 'lightblue', fontSize: '30px' }} />,
  seguridad: <FaShieldAlt style={{ color: 'red', fontSize: '30px' }} />,
  techos: <FaBuilding style={{ color: 'yellow', fontSize: '30px' }} />,
  contratista: <FaToolbox style={{ color: 'gray', fontSize: '30px' }} />,
  oferta: <FaHandshake style={{ color: '#4CAF50', fontSize: '30px' }} />,
  demanda: <FaSearch style={{ color: '#2196F3', fontSize: '30px' }} />,
};

const services = [
  { type: 'pintor', description: 'pintura', minBudget: 300, maxBudget: 800 },
  { type: 'electricista', description: 'electricidad', minBudget: 500, maxBudget: 1200 },
  { type: 'fontanero', description: 'fontanería', minBudget: 400, maxBudget: 1000 },
  { type: 'albanil', description: 'albañilería', minBudget: 800, maxBudget: 2000 },
  { type: 'carpintero', description: 'carpintería', minBudget: 500, maxBudget: 1500 },
  { type: 'jardinero', description: 'jardinería', minBudget: 200, maxBudget: 700 },
  { type: 'aire_acondicionado', description: 'aire acondicionado', minBudget: 600, maxBudget: 1800 },
  { type: 'seguridad', description: 'sistemas de seguridad', minBudget: 700, maxBudget: 2500 },
  { type: 'techos', description: 'instalación de techos', minBudget: 1000, maxBudget: 5000 },
  { type: 'contratista', description: 'servicios de contratista', minBudget: 1500, maxBudget: 7000 },
];

const clients = [
  'María', 'Carlos', 'Lucía', 'Javier', 'Ana', 'Fernando', 'Laura', 'Pedro', 'Marta', 'José',
];

// Coordenadas reales de ciudades principales (evita marcadores en el agua)
const realLocations = [
  // Miami y alrededores
  { lat: 25.7617, lng: -80.1918, city: 'Miami Downtown' },
  { lat: 25.7907, lng: -80.1300, city: 'Miami Beach' },
  { lat: 25.8756, lng: -80.1378, city: 'North Miami' },
  { lat: 25.8929, lng: -80.1350, city: 'North Miami Beach' },
  { lat: 25.9431, lng: -80.1495, city: 'Aventura' },
  { lat: 25.7089, lng: -80.3197, city: 'Doral' },
  { lat: 25.6866, lng: -80.3156, city: 'Sweetwater' },
  { lat: 25.5517, lng: -80.3197, city: 'Kendall' },
  { lat: 25.6020, lng: -80.3977, city: 'West Kendall' },
  { lat: 25.6772, lng: -80.3133, city: 'Coral Gables' },
  { lat: 25.8540, lng: -80.1902, city: 'Hialeah' },
  { lat: 25.9564, lng: -80.2453, city: 'Miami Gardens' },
  { lat: 25.5585, lng: -80.3568, city: 'Pinecrest' },
  { lat: 25.5918, lng: -80.3203, city: 'South Miami' },
  { lat: 25.8223, lng: -80.2433, city: 'Miami Lakes' },
  { lat: 26.0112, lng: -80.1495, city: 'Sunny Isles Beach' },
  { lat: 25.9743, lng: -80.1437, city: 'Golden Beach' },
  { lat: 25.8803, lng: -80.3238, city: 'Medley' },
  { lat: 25.6586, lng: -80.2987, city: 'Coconut Grove' },
  { lat: 25.7753, lng: -80.2089, city: 'Brickell' },
  // Fort Lauderdale
  { lat: 26.1224, lng: -80.1373, city: 'Fort Lauderdale' },
  { lat: 26.1901, lng: -80.1673, city: 'Pompano Beach' },
  { lat: 26.2380, lng: -80.1248, city: 'Deerfield Beach' },
  // West Palm Beach
  { lat: 26.7153, lng: -80.0534, city: 'West Palm Beach' },
  { lat: 26.7056, lng: -80.0364, city: 'Palm Beach' },
  // Orlando
  { lat: 28.5383, lng: -81.3792, city: 'Orlando' },
  { lat: 28.5421, lng: -81.2089, city: 'Winter Park' },
  // Tampa
  { lat: 27.9506, lng: -82.4572, city: 'Tampa' },
  { lat: 27.7676, lng: -82.6403, city: 'St. Petersburg' },
  // Jacksonville
  { lat: 30.3322, lng: -81.6557, city: 'Jacksonville' },
  // Ciudades de Colombia
  { lat: 4.7110, lng: -74.0721, city: 'Bogotá' },
  { lat: 6.2442, lng: -75.5812, city: 'Medellín' },
  { lat: 3.4516, lng: -76.5320, city: 'Cali' },
  { lat: 10.9685, lng: -74.7813, city: 'Barranquilla' },
  { lat: 7.1254, lng: -73.1198, city: 'Bucaramanga' },
  // Ciudades de España
  { lat: 40.4168, lng: -3.7038, city: 'Madrid' },
  { lat: 41.3851, lng: 2.1734, city: 'Barcelona' },
  { lat: 39.4699, lng: -0.3763, city: 'Valencia' },
  { lat: 37.3891, lng: -5.9845, city: 'Sevilla' },
  // Ciudades de México
  { lat: 19.4326, lng: -99.1332, city: 'Ciudad de México' },
  { lat: 20.6597, lng: -103.3496, city: 'Guadalajara' },
  { lat: 25.6866, lng: -100.3161, city: 'Monterrey' },
  // Ciudades de Argentina
  { lat: -34.6037, lng: -58.3816, city: 'Buenos Aires' },
  { lat: -31.4201, lng: -64.1888, city: 'Córdoba' },
  // Ciudades de Chile
  { lat: -33.4489, lng: -70.6693, city: 'Santiago' },
  { lat: -33.0472, lng: -71.6127, city: 'Valparaíso' },
];

const getRandomService = () => services[Math.floor(Math.random() * services.length)];
const getRandomClient = () => clients[Math.floor(Math.random() * clients.length)];
const getRandomBudget = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
const getRandomLocation = () => realLocations[Math.floor(Math.random() * realLocations.length)];

const MapView = () => {
  const mapContainer = useRef(null);
  const map = useRef(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [currentMarkers, setCurrentMarkers] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    type: 'oferta',
    service: 'pintor',
    budget: '',
    address: '',
  });

  const openChat = (clientName) => {
    alert(`Iniciar chat con ${clientName}`);
  };

  const addMarker = useCallback((newMarker) => {
    const el = document.createElement('div');
    el.innerHTML = ReactDOMServer.renderToString(icons[newMarker.iconType]);

    const popupContent = `
      <div style="text-align: center;">
        <h3>${newMarker.name}</h3>
        <p>${newMarker.description}</p>
        <button onclick="window.openChat('${newMarker.name}')" style="padding: 8px 16px; background-color: #1DA1F2; color: white; border: none; border-radius: 5px; cursor: pointer;">
          Iniciar Chat
        </button>
      </div>
    `;

    const marker = new mapboxgl.Marker(el)
      .setLngLat([newMarker.lng, newMarker.lat])
      .setPopup(new mapboxgl.Popup({ offset: 25 }).setHTML(popupContent))
      .addTo(map.current);

    setCurrentMarkers((prevMarkers) => [...prevMarkers, { ...newMarker, markerObject: marker }]);
  }, []);

  const generateRandomMarkers = useCallback((center, count = 2) => {
    for (let i = 0; i < count; i++) {
      const service = getRandomService();
      const client = getRandomClient();
      const budget = getRandomBudget(service.minBudget, service.maxBudget);
      const type = Math.random() > 0.5 ? 'oferta' : 'demanda';
      
      // Usar ubicaciones reales en lugar de coordenadas aleatorias
      const location = getRandomLocation();
      
      // Agregar una pequeña variación para que no todos estén en el mismo punto
      const latVariation = (Math.random() - 0.5) * 0.02; // ~1km de variación
      const lngVariation = (Math.random() - 0.5) * 0.02;

      const newMarker = {
        lat: location.lat + latVariation,
        lng: location.lng + lngVariation,
        name: client,
        description: `${type === 'oferta' ? 'Ofrece' : 'Solicita'} ${service.description} en ${location.city} con un presupuesto de $${budget}`,
        iconType: type,
      };
      addMarker(newMarker);
    }
  }, [addMarker]);

  const centerMapOnUserLocation = () => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          map.current.flyTo({
            center: [longitude, latitude],
            zoom: 13
          });
        },
        (error) => {
          console.error("Error getting user location:", error);
          alert("No se pudo obtener tu ubicación. Por favor, verifica los permisos de ubicación.");
        }
      );
    } else {
      alert("Tu navegador no soporta geolocalización.");
    }
  };

  useEffect(() => {
    if (!map.current) {
      map.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: 'mapbox://styles/qbanito/cm0lt0yp0027q01qr12wf4zh7',
        center: [-80.1918, 25.7617], // Miami, Florida
        zoom: 13,
      });

      map.current.on('load', () => {
        setMapLoaded(true);
        generateRandomMarkers(map.current.getCenter(), 20);
      });

      map.current.on('moveend', () => {
        generateRandomMarkers(map.current.getCenter(), 10);

        // Remove markers that are no longer in view
        setCurrentMarkers((prevMarkers) => {
          const bounds = map.current.getBounds();
          return prevMarkers.filter((marker) => {
            if (!bounds.contains([marker.lng, marker.lat])) {
              marker.markerObject.remove();
              return false;
            }
            return true;
          });
        });
      });
    }

    window.openChat = openChat;
  }, [generateRandomMarkers]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const geocodingUrl = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(formData.address)}.json?access_token=${mapboxgl.accessToken}`;

    fetch(geocodingUrl)
      .then(response => response.json())
      .then(data => {
        if (data.features && data.features.length > 0) {
          const [lng, lat] = data.features[0].center;
          const newMarker = {
            lat,
            lng,
            name: formData.name,
            description: `${formData.type === 'oferta' ? 'Ofrece' : 'Solicita'} ${formData.service} con un presupuesto de $${formData.budget}`,
            iconType: formData.type,
          };
          addMarker(newMarker);
          map.current.flyTo({
            center: [lng, lat],
            zoom: 13
          });
          setFormData({
            name: '',
            type: 'oferta',
            service: 'pintor',
            budget: '',
            address: '',
          });
        } else {
          alert('No se pudo encontrar la dirección. Por favor, intenta de nuevo.');
        }
      })
      .catch(error => {
        console.error('Error al geocodificar:', error);
        alert('Hubo un error al procesar la dirección. Por favor, intenta de nuevo.');
      });
  };

  return (
    <div className="mt-12 bg-white p-6 rounded-lg shadow-lg">
      <h2 className="text-3xl font-bold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-blue-600">
        Encuentra un proveedor cerca de ti
      </h2>
      <div className="flex flex-col md:flex-row gap-6">
        <div className="w-full md:w-2/3 relative">
          <div ref={mapContainer} className="map-container" style={{ height: '500px', width: '100%' }} />
          <button 
            onClick={centerMapOnUserLocation}
            className="absolute top-4 right-4 bg-white p-2 rounded-full shadow-md"
            title="Centrar en tu ubicación"
          >
            <FaLocationArrow className="text-blue-500" />
          </button>
        </div>
        <div className="w-full md:w-1/3">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="name" className="block text-sm font-medium text-gray-700">Nombre</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
              />
            </div>
            <div>
              <label htmlFor="type" className="block text-sm font-medium text-gray-700">Tipo</label>
              <select
                id="type"
                name="type"
                value={formData.type}
                onChange={handleChange}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
              >
                <option value="oferta">Oferta</option>
                <option value="demanda">Demanda</option>
              </select>
            </div>
            <div>
              <label htmlFor="service" className="block text-sm font-medium text-gray-700">Servicio</label>
              <select
                id="service"
                name="service"
                value={formData.service}
                onChange={handleChange}
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
              >
                {services.map((service) => (
                  <option key={service.type} value={service.type}>{service.description}</option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="budget" className="block text-sm font-medium text-gray-700">Presupuesto</label>
              <input
                type="number"
                id="budget"
                name="budget"
                value={formData.budget}
                onChange={handleChange}
                required
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
              />
            </div>
            <div>
              <label htmlFor="address" className="block text-sm font-medium text-gray-700">Dirección</label>
              <input
                type="text"
                id="address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                required
                className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
              />
            </div>
            <div>
              <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Agregar Servicio
              </button>
              </div>
              </form>
              </div>
              </div>
              </div>
              );
              };

              export default MapView;